import { Skeleton } from "@mantine/core";
import classes from "./index.module.css";

/** Esqueleto da aba: card explicativo, barra de busca + botão e 4 linhas. */
export function QuickRepliesSettingsTabSkeleton() {
  return (
    <div className={classes.page}>
      <Skeleton
        h={96}
        radius="lg"
      />
      <div className={classes.toolbar}>
        <Skeleton
          h={40}
          radius="md"
          className={classes.search}
        />
        <Skeleton
          h={36}
          w={190}
          radius="md"
        />
      </div>
      <div className={classes.list}>
        {Array.from({ length: 4 }).map((_, index) => (
          <Skeleton
            key={index}
            h={64}
            radius={0}
          />
        ))}
      </div>
    </div>
  );
}

export default QuickRepliesSettingsTabSkeleton;
